import React from 'react';
import { motion } from 'framer-motion';
import { Layout } from '../layout/Layout';
import { MapPin, Phone, Globe, Mail, MessageSquare, ArrowRight } from 'lucide-react';
import { useChatStore } from '../../store/chatStore';

export function ContactPage() {
  const { setIsOpen } = useChatStore();

  return (
    <Layout>
      <div className="bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
          <div className="grid md:grid-cols-2 gap-8 lg:gap-12 items-start">
            {/* Contact Information */}
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              className="bg-white p-6 md:p-8 rounded-xl shadow-sm"
            >
              <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6 md:mb-8">
                Contact Eye Catching Media
              </h1>
              
              <div className="space-y-6">
                <div className="flex items-start gap-3 md:gap-4">
                  <div className="w-8 h-8 md:w-10 md:h-10 bg-brand-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <MapPin className="w-4 h-4 md:w-5 md:h-5 text-brand-600" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1">Bezoekadres</h3>
                    <p className="text-gray-600 text-sm md:text-base">
                      Kerseboom 13<br />
                      4101 VM Culemborg<br />
                      Gelderland<br />
                      Nederland
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-3 md:gap-4">
                  <div className="w-8 h-8 md:w-10 md:h-10 bg-brand-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Phone className="w-4 h-4 md:w-5 md:h-5 text-brand-600" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1">Telefoon</h3>
                    <a 
                      href="tel:+31850716719" 
                      className="text-brand-600 hover:text-brand-700 transition-colors text-sm md:text-base"
                    >
                      +31 (0)6 50423 583
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-3 md:gap-4">
                  <div className="w-8 h-8 md:w-10 md:h-10 bg-brand-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Globe className="w-4 h-4 md:w-5 md:h-5 text-brand-600" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1">Website</h3>
                    <a 
                      href="https://www.eye-catchingmedia.com" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-brand-600 hover:text-brand-700 transition-colors text-sm md:text-base break-words"
                    >
                      www.eye-catchingmedia.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-3 md:gap-4">
                  <div className="w-8 h-8 md:w-10 md:h-10 bg-brand-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Mail className="w-4 h-4 md:w-5 md:h-5 text-brand-600" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1">E-mail</h3>
                    <a 
                      href="mailto:info@eye-catchingmedia.com"
                      className="text-brand-600 hover:text-brand-700 transition-colors text-sm md:text-base break-words"
                    >
                      info@eye-catchingmedia.com
                    </a>
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Chat CTA */}
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              className="bg-brand-50 p-6 md:p-8 rounded-xl relative overflow-hidden"
            >
              {/* Decorative elements */}
              <div className="absolute -right-8 -top-8 w-24 md:w-32 h-24 md:h-32 bg-brand-100 rounded-full opacity-50" />
              <div className="absolute -left-8 -bottom-8 w-20 md:w-24 h-20 md:h-24 bg-brand-100 rounded-full opacity-50" />
              
              <div className="relative">
                <div className="flex items-center gap-3 mb-4 md:mb-6">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-brand-100 rounded-lg flex items-center justify-center">
                    <MessageSquare className="w-5 h-5 md:w-6 md:h-6 text-brand-600" />
                  </div>
                  <h2 className="text-xl md:text-2xl font-bold text-gray-900">
                    Direct Contact
                  </h2>
                </div>

                <p className="text-base md:text-lg text-gray-600 mb-6 md:mb-8">
                  Chat direct met een van onze specialisten voor snelle antwoorden op al uw vragen.
                </p>

                <motion.div
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.2 }}
                >
                  <button
                    onClick={() => setIsOpen(true)}
                    className="w-full bg-brand-600 text-white px-4 md:px-6 py-3 rounded-lg font-semibold hover:bg-brand-700 transition-colors flex items-center justify-center gap-2"
                  >
                    Start Direct Chat
                    <ArrowRight className="w-4 h-4 md:w-5 md:h-5" />
                  </button>
                </motion.div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
